import { AppLayout } from "@bcc/components/app-layout";
import { FinanceInvoicesView } from "@bcc/components/views/finance-invoices-view";
import type { InvoiceFilters } from "@bcc/lib/types/invoice";

export function FinanceInvoicesPage() {
  const initialFilters: InvoiceFilters = {};

  return (
    <AppLayout>
      <FinanceInvoicesView initialFilters={initialFilters} />
    </AppLayout>
  );
}
